export default {
  name: 'medicine-edit',
  data: function () {
    return {
      additionalComment: '',
      searchCallbackFlag: false
    }
  },
  created() {
    // システム管理者 または 薬剤師
    this.$store.dispatch('USER_ADMIN_PHARMACIST')

    this.clearMedicine()
    this.search()
  },
  computed: {
    medicine() {
      return this.$store.getters.medicine
    },
    sideEffects() {
      return this.$store.getters.sideEffects
    },
    /** システム管理者 または 薬剤師 */
    isAdminOrPharmacist() {
      return this.$store.getters.userAdminOrPharmacist
    },
    loading() {
      return this.$store.getters.apiLoading
    },
    /** 通知 */
    notify () {
      return this.$store.getters.medicinesNotify
    }
  },
  methods: {
    search: function () {
      var self = this
      var callback = function (med) {
        self.additionalComment =   med.attributes['additional-comment']
        self.searchCallbackFlag = true
      }
      this.searchCallbackFlag = false
      this.$store.dispatch('MEDICINE_DETAIL', { medicineId: this.$route.params.medicineId, callback: callback})
    },
    clearMedicine: function () {
      this.$store.dispatch('MEDICINE_DETAIL_CLEAR')
    },
    goMedicinesDetail: function(medicineId) {
      this.$router.push({ path: '/medicines/' + medicineId})
    },
    getAgeText: function(sideEffect) {
      var ageTexts = []
      if (sideEffect.attributes['age-m-low'] !== null && sideEffect.attributes['age-m-low'] !== null){
        ageTexts.push( this.$t('age',{'age': this.$t('Male') + '：' + sideEffect.attributes['age-m-low'] + '～' + sideEffect.attributes['age-m-high']} ) )
      }
      if (sideEffect.attributes['age-f-low'] !== null && sideEffect.attributes['age-f-low'] !== null){
        ageTexts.push( this.$t('age',{'age': this.$t('Female') + '：' + sideEffect.attributes['age-f-low'] + '～' + sideEffect.attributes['age-f-high']}) )
      }
      return ageTexts.length > 0 ? '（' + ageTexts.join('、') + '）' : ''
    },
    updateAdditionalComment: function () {
      var medichineId = this.$route.params.medicineId
      var self = this
      var data = {'additional_comment': this.additionalComment}
      this.$store.dispatch('MEDICINE_UPDATE_COMMENT', {
        medicineId: medichineId,
        data: data,
        callback: (data) => { self.$router.push({ path: '/medicines/' + medichineId}) }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/medicine-edit.js